import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { DividerProps } from "./types";

const Divider = ({ marginBottom, hasMarginOnTop }: DividerProps) => {
    const { gray300 } = colors;

    return (
        <div
            css={css({
                height: "1px",
                width: "100%",
                backgroundColor: gray300,
                marginTop: hasMarginOnTop ? "12px" : "0",
                marginBottom: marginBottom || "0"
            })}
        ></div>
    );
};

export default Divider;
